import { render } from "./Competent.vue?vue&type=template&id=2d9d4168"
import script from "./Competent.vue?vue&type=script&lang=js"
export * from "./Competent.vue?vue&type=script&lang=js"

import exportComponent from "/home/soviko/htdocs/soviko.de/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__